import { useEffect, useRef } from 'react'
import { useAuth } from 'react-oidc-context'
import { useNavigate } from 'react-router-dom'
const { VITE_COMPANION_APP_URL } = import.meta.env

interface AuthState {
  returnUrl: string
}

function CallbackSignInApp() {
  const navigate = useNavigate()
  const { signinSilent, signinRedirect, user: authUser, isLoading } = useAuth()
  const hasRun = useRef(false)

  useEffect(() => {
    if (isLoading || hasRun.current) return

    const refresh = async () => {
      try {
        const user = await signinSilent()
        const userWithState = authUser as { state?: AuthState }
        if (
          userWithState?.state?.returnUrl &&
          !userWithState?.state?.returnUrl
            .toLocaleLowerCase()
            .includes('callbacksigninapp')
        ) {
          hasRun.current = true
          navigate(userWithState.state.returnUrl)
          return
        }
        if (user?.access_token) {
          hasRun.current = true
          console.log('Token refreshed successfully:', user)
          window.location.href = `${VITE_COMPANION_APP_URL}?access_token=${user.access_token}`
        } else {
          throw new Error('No access token received from silent signin')
        }
      } catch (error) {
        console.error('Silent signin failed:', error)
        try {
          await signinRedirect({
            state: {
              returnUrl: `${window.location.pathname}${window.location.search}`,
            },
          })
        } catch (redirectError) {
          console.error('Signin redirect failed:', redirectError)
        }
      }
    }

    void refresh()
  }, [authUser, isLoading, signinSilent, signinRedirect, navigate])

  return null
}

export { CallbackSignInApp }
